"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const e_1 = require("e");
const monsterData_1 = require("../meta/monsterData");
const util_1 = require("../util/util");
const Bank_1 = __importDefault(require("./Bank"));
const Monster_1 = __importDefault(require("./Monster"));
class SimpleMonster extends Monster_1.default {
    constructor(options) {
        let allItems = [];
        if (options.table) {
            allItems = allItems.concat(options.table.allItems);
        }
        if (options.pickpocketTable) {
            allItems = allItems.concat(options.pickpocketTable.allItems);
        }
        super(Object.assign(Object.assign({}, options), { allItems: allItems }));
        this.table = options.table;
        this.pickpocketTable = options.pickpocketTable;
        this.onTaskTable = options.onTaskTable;
        this.customKillLogic = options.customKillLogic;
    }
    kill(quantity = 1, options = {}) {
        const loot = new Bank_1.default();
        const canGetKey = options.onSlayerTask && options.slayerMaster === monsterData_1.MonsterSlayerMaster.Konar;
        for (let i = 0; i < quantity; i++) {
            if (canGetKey) {
                if (e_1.roll(util_1.getBrimKeyChanceFromCBLevel(this.data.combatLevel))) {
                    loot.add('Brimstone key');
                }
            }
            if (options.onSlayerTask && this.name.toLowerCase() === 'gargoyle' && e_1.roll(150)) {
                loot.add('Brittle key');
            }
            if (options.inCatacombs) {
                if (e_1.roll(util_1.getAncientShardChanceFromHP(this.data.hitpoints))) {
                    loot.add('Ancient shard');
                }
                if (e_1.roll(util_1.getTotemChanceFromHP(this.data.hitpoints))) {
                    // Always drop Dark totem base and bot will transmog accordingly.
                    loot.add('Dark totem base');
                }
            }
            if (options.onSlayerTask) {
                if (options.hasSuperiors && e_1.roll(200)) {
                    // Superiors always drop totem piece in catacombs.
                    if (options.inCatacombs)
                        loot.add('Dark totem base');
                    // track number of superiors with this item (Distillator).
                    loot.add({ [420]: 1 });
                    loot.add(options.hasSuperiors.table.roll());
                }
                else if (this.onTaskTable) {
                    // Roll the monster's "on-task" table.
                    loot.add(this.onTaskTable.roll());
                }
                else {
                    // Monster doesn't have a unique on-slayer table
                    loot.add(this.table.roll());
                }
            }
            else {
                // Not on slayer task
                loot.add(this.table.roll());
            }
            if (this.customKillLogic) {
                this.customKillLogic(options, loot);
            }
        }
        return loot;
    }
}
exports.default = SimpleMonster;
//# sourceMappingURL=SimpleMonster.js.map